export default __webpack_public_path__ + "static/media/WB_logo_below_brown.53a308a4.png";